/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FufiAllocationRateItem
 */
export interface FufiAllocationRateItem {
    /**
     * 
     * @type {string}
     * @memberof FufiAllocationRateItem
     */
    fundCode: string;
    /**
     * 
     * @type {number}
     * @memberof FufiAllocationRateItem
     */
    allocation: number;
    /**
     * 
     * @type {string}
     * @memberof FufiAllocationRateItem
     */
    fundName?: string | null;
}

/**
 * Check if a given object implements the FufiAllocationRateItem interface.
 */
export function instanceOfFufiAllocationRateItem(value: object): value is FufiAllocationRateItem {
    if (!('fundCode' in value) || value['fundCode'] === undefined) return false;
    if (!('allocation' in value) || value['allocation'] === undefined) return false;
    return true;
}

export function FufiAllocationRateItemFromJSON(json: any): FufiAllocationRateItem {
    return FufiAllocationRateItemFromJSONTyped(json, false);
}

export function FufiAllocationRateItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FufiAllocationRateItem {
    if (json == null) {
        return json;
    }
    return {
        
        'fundCode': json['fundCode'],
        'allocation': json['allocation'],
        'fundName': json['fundName'] == null ? undefined : json['fundName'],
    };
}

export function FufiAllocationRateItemToJSON(json: any): FufiAllocationRateItem {
    return FufiAllocationRateItemToJSONTyped(json, false);
}

export function FufiAllocationRateItemToJSONTyped(value?: FufiAllocationRateItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fundCode': value['fundCode'],
        'allocation': value['allocation'],
        'fundName': value['fundName'],
    };
}

